// @ts-check
// Aplicación del ESTILO visual en la barra superior (DEC-103, DEC-108).
//
// ## Qué queda de este módulo y qué se fue
//
// Nació construyendo el bloque de ajustes de la barra (estilo + tema). Desde
// DEC-108 esos conmutadores viven en el perfil del alumno, no en la barra, así
// que aquí ya no se pinta ningún control.
//
// Lo que SÍ sigue haciendo falta es APLICAR el estilo guardado, y por eso el
// módulo no desaparece: quitarlo del todo tentaría a alguien a borrar también
// esa llamada, que es exactamente el fallo que se corrigió el 2026-08-02 (el
// alumno elegía Plano y media aplicación volvía a Clásico al navegar).
//
// Hoy el arranque común (`app/bootstrap.js`) ya lo aplica en todas las
// páginas, incluidas las que no montan barra. Esta llamada es la segunda
// barrera: idempotente, sin coste, y hace que ninguna de las dos capas dependa
// de la otra.

import { restaurarEstilo } from '../state/visual-style.js';

/**
 * Aplica al documento el estilo visual guardado.
 * @returns {import('../state/visual-style.js').EstiloVisual}
 */
export function aplicarEstiloGuardado() {
  return restaurarEstilo();
}
